import letter from "../assets/letter-about.png";
import { useTranslation, Trans } from "react-i18next";


export default function WorkTogetherCta() {
  const { t } = useTranslation();
  return (
    <section className="mx-auto px-[20px] py-8">
      <div className="grid grid-cols-1 lg:grid-cols-2 rounded-2xl overflow-hidden shadow-sm bg-[#F4F2FC] justify-between">
        {/* Левая колонка — ровно 330px */}
        <div className="px-6 sm:px-10 flex items-center h-[330px]">
          <div className="max-w-md">
            <h1 className="text-lg font-semibold text-gray-900">
              <Trans
                i18nKey="$Header12"
                components={{ highlight: <span className="text-purple-600 underline decoration-purple-300" /> }}
              />
            </h1>

            <p className="mt-6 text-2xl font-semibold text-gray-900 leading-snug">
              <Trans
                i18nKey="$Subheader17"
                components={{ highlight: <span className="mt-2 text-xs text-gray-500"></span> }}
              />
              
            </p>

            <button
              className="mt-6 inline-flex items-center gap-2 rounded-full bg-black text-white px-5 py-2 text-sm font-medium hover:opacity-90 transition"
              type="button"
              onClick={() => {
                window.location.href = "mailto:info@best-practices.online";
              }}
            >
              {t('$Buttom5')} <span aria-hidden>→</span>
            </button>
          </div>
        </div>

        {/* Правая колонка — тоже 330px */}
        <div className="relative h-[330px]">
          <div className="absolute inset-0 rounded-r-2xl" />
          <div className="h-full w-full flex items-center justify-center">
            <img
              src={letter}
              alt="Письмо"
              className="h-[330px] w-auto object-contain"
              loading="lazy"
              decoding="async"
              draggable={false}
            />
          </div>
        </div>
      </div>
    </section>
  );
}
